module.exports = __webpack_public_path__ + "static/media/03_MIT.ebdc801b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/03_MIT.png
// module id = 531
// module chunks = 0